// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccd-content {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.ccd-icon {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 50%;
}

.ccd-danger .ccd-icon {
  background: var(--cui-danger-soft);
  color: var(--cui-danger);
}

.ccd-warning .ccd-icon {
  background: var(--cui-warning-soft);
  color: var(--cui-warning);
}

.ccd-primary .ccd-icon {
  background: var(--cui-primary-soft);
  color: var(--cui-primary);
}

.ccd-text {
  min-width: 0;
}

.ccd-title {
  margin: 2px 0 0;
  color: var(--cui-text);
  font-size: 16px;
  font-weight: 700;
}

.ccd-message {
  margin-top: 6px;
  color: var(--cui-text-muted);
  font-size: var(--cui-font-size);
  line-height: 1.55;
  overflow-wrap: anywhere;
}

@media (max-width: 576px) {
  .ccd-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomConfirmDialog/CustomConfirmDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".ccd-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.ccd-icon {\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.ccd-danger .ccd-icon {\n  background: var(--cui-danger-soft);\n  color: var(--cui-danger);\n}\n\n.ccd-warning .ccd-icon {\n  background: var(--cui-warning-soft);\n  color: var(--cui-warning);\n}\n\n.ccd-primary .ccd-icon {\n  background: var(--cui-primary-soft);\n  color: var(--cui-primary);\n}\n\n.ccd-text {\n  min-width: 0;\n}\n\n.ccd-title {\n  margin: 2px 0 0;\n  color: var(--cui-text);\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.ccd-message {\n  margin-top: 6px;\n  color: var(--cui-text-muted);\n  font-size: var(--cui-font-size);\n  line-height: 1.55;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 576px) {\n  .ccd-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
